import { timeline, TimelineDefinition, inView } from 'motion';

export const LoadSequence = (
  section: HTMLElement,
  animateElements: {
    element: HTMLElement;
    y?: number[];
    opacity?: number[];
    addScale?: boolean | null;
    offset?: string | number;
  }[],
  onComplete?: () => void
) => {
  const sequence: TimelineDefinition = animateElements.map(item => {
    return [
      item.element,
      {
        y: item.y ? item.y : [-32, 0],
        opacity: item.opacity ? item.opacity : [0, 1],
        scale: item.addScale ? [0.9, 1] : [1, 1],
        transformOrigin: 'center top',
        easing: 'ease-in-out'
      },
      { duration: 0.6, at: item.offset ?? 0 }
    ];
  });

  inView(section, () => {
    timeline(sequence).finished.then(() => {
      if (onComplete) {
        onComplete();
      }
    });
  });
};

export const LoadSequenceBasic = (
  animateElements: {
    element: HTMLElement;
    y?: number[];
    opacity?: number[];
    addScale: boolean;
    offset?: string | number | undefined;
    transformOrigin?: string;
  }[],
  onComplete?: () => void
) => {
  const sequence: TimelineDefinition = animateElements.map(item => {
    return [
      item.element,
      {
        y: item.y ? item.y : [-32, 0],
        opacity: item.opacity ? item.opacity : [0, 1],
        scale: item.addScale ? [0.9, 1] : [1, 1],
        transformOrigin: item.transformOrigin || 'center top',
        easing: 'ease-in-out'
      },
      { duration: 0.6, at: item.offset ?? 0 }
    ];
  });

  timeline(sequence).finished.then(() => {
    if (onComplete) {
      onComplete();
    }
  });
};

export const GenerateLoadSequence = (
  array: HTMLElement[],
  offset?: number
): {
  element: HTMLElement;
  addScale: boolean | null;
  offset?: string | number | undefined;
}[] => {
  return array.map((item, index) => ({
    element: item,
    addScale: false,
    offset: 0.1 * (index + 1 + (offset ?? 0))
  }));
};
